import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Platform } from "@ionic/angular";

@Injectable()
export class CookieAuthService {
  constructor(
    private _cookieService: CookieService,
    private platform: Platform
  ) {}

  /**
   * A function to get cookie values
   * For Web & Android, `CookieService` works just fine, but on iOS we have hostname `ionic://wakandi.com`,
   * and because of iOS's security restriction we can't access cross domain cookies, causing issues especially
   * in cases where we need a cookie value (for API headers it works fine).
   * So here for Web & Android we use `CookieService` but for iOS we get it through `sslHTTP` or `sslSupport` plugin natively
   * @param cookieName cookie name
   * @returns cookie value
   */
  getCookie(cookieName: string) {
    return new Promise<string>((resolve) => {
      if (this.platform.is('cordova') && this.platform.is("ios")) {
        window["sslHTTP"].getCookies(
          "wakandi.com",
          function (cookies) {
            const sslNativecookie = cookies[cookieName];
            resolve(sslNativecookie ? sslNativecookie.value : "");
          },
          function () {
            resolve("");
          }
        );
      } else {
        resolve(this._cookieService.get(cookieName));
      }
    });
  }
}
